package com.kaihuoy.web

import kotlinx.coroutines.await
import kotlinx.serialization.Serializable
import kotlin.js.JsName
import kotlin.js.Promise
import kotlin.js.Date

data class PushNotificationSetupResult(
    val ok: Boolean,
    val message: String,
    val code: String
)

@Serializable
private data class WebNotificationSubscription(
    val token: String,
    val displayName: String,
    val platform: String = "web",
    val updatedAt: Long,
    val userAgent: String = ""
)

@JsName("initializeKaihuPushNotifications")
private external fun initializeKaihuPushNotificationsJs(userId: String, displayName: String): Promise<dynamic>

suspend fun initializeKaihuPushNotifications(userId: String, displayName: String): PushNotificationSetupResult {
    val result = initializeKaihuPushNotificationsJs(userId, displayName).await()
    val ok = result.ok as? Boolean ?: false
    val message = result.message as? String ?: "Ilmoitusten käyttöönotto epäonnistui."
    val code = result.code as? String ?: "unknown"

    if (ok) {
        val token = result.token as? String
        if (token.isNullOrBlank()) {
            return PushNotificationSetupResult(
                ok = false,
                message = "Push-token puuttuu, joten ilmoituksia ei voitu tallentaa.",
                code = "missing-token"
            )
        }

        FirebaseService.database.reference("notificationSubscriptions")
            .child(userId)
            .child("web")
            .setValue(
                WebNotificationSubscription(
                    token = token,
                    displayName = displayName,
                    updatedAt = Date.now().toLong(),
                    userAgent = result.userAgent as? String ?: ""
                )
            )

        return PushNotificationSetupResult(
            ok = true,
            message = "Ilmoitukset otettiin käyttöön onnistuneesti tällä laitteella.",
            code = "enabled"
        )
    }

    return PushNotificationSetupResult(
        ok = ok,
        message = message,
        code = code
    )
}